import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/** Tailwind-aware className combiner (the shadcn/ui `cn` convention). */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
